import React from "react"
import { Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { Scale } from "chroma-js"
import styled from "styled-components"

type THeadingAlign = "left" | "center"

interface IHeadingProps {
  /**
   * Text align
   * @default "left"
   */
  align: THeadingAlign
  /**
   * TODO
   * @default true
   */
  rule: boolean
  /**
   * With of rule divider line
   * @default 200
   */
  ruleWidth: string | number
  /**
   * Subtitle
   * @default ""
   */
  subtitle: string
  /**
   * Title
   * @default ""
   */
  title: string
  /**
   * Typography variant
   */
  variant: "h1" | "h2" | "h3" | "h4"
}

const HeadingWrap = styled.hgroup<{ align: THeadingAlign }>`
  margin: 1rem 0;
  white-space: nowrap;
  text-align: ${({ align }) => align};

  > p {
  }

  > p::before {
    content: "";
  }
`

const HR = styled.hr<{
  align: THeadingAlign
  colorScale: Scale
}>`
  background: ${({ align, colorScale }) =>
    align === "center"
      ? colorScale(0).css()
      : `linear-gradient(
    90deg,
        ${colorScale(0).alpha(1).css()}
      0%,
    
        ${colorScale(1).alpha(0.3).css()}
      100%
  )`};
  height: 1px;
  border: none;
  margin: ${({ align }) => (align === "center" ? "1rem auto 0" : "1rem 0 0")};
`

const Heading = ({
  align = "left",
  rule = true,
  ruleWidth = 200,
  subtitle,
  title,
  variant
}: IHeadingProps) => {
  const theme = useTheme()
  if (!variant) {
    return "Variant prop missing. Should be h1|h2|h3|h4"
  }

  return (
    <HeadingWrap align={align}>
      <Typography variant={variant}>{title}</Typography>
      <Typography variant="subtitle1">{subtitle}</Typography>
      {rule ? (
        <HR
          align={align}
          colorScale={theme.colorScales.light as Scale}
          style={{ width: ruleWidth }}
        />
      ) : (
        ""
      )}
    </HeadingWrap>
  )
}

export default Heading
